'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import Controllable from '../decorators/Controllable';
import { OptionType } from '../types/OptionTypes';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import partial from 'react-utils/partial';
import SyntheticEvent from '../core/SyntheticEvent';
import UIButton from '../button/UIButton';
import UIButtonGroup from '../button/UIButtonGroup';
import UITooltip from '../tooltip/UITooltip';

class UIViewController extends PureComponent {
  constructor(...args) {
    super(...args);

    this.handleChange = (newValue, evt) => {
      const {
        onChange,
        value
      } = this.props;

      if (newValue === value) {
        return;
      }

      onChange(SyntheticEvent(newValue, evt));
    };
  }

  render() {
    const _this$props = this.props,
          {
      options,
      size,
      value
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["onChange", "options", "size", "value"]);

    return /*#__PURE__*/_jsx(UIButtonGroup, Object.assign({
      className: "private-button-select-group"
    }, rest, {
      role: "radiogroup",
      children: options.map(option => {
        const isActive = option.value === value;
        const {
          'data-test-id': dataTestId
        } = option;
        return /*#__PURE__*/_jsx(UITooltip, {
          title: option.title,
          children: /*#__PURE__*/_jsx(UIButton, {
            active: isActive,
            "aria-checked": isActive,
            className: "private-button-select-group__option",
            "data-test-id": dataTestId,
            disabled: option.disabled,
            onClick: partial(this.handleChange, option.value),
            responsive: false,
            role: "radio",
            size: size,
            use: "tertiary-light",
            children: option.buttonText || option.text || option.value
          })
        }, option.value);
      })
    }));
  }

}

UIViewController.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(OptionType.isRequired).isRequired,
  size: UIButton.propTypes.size,
  value: PropTypes.any
};
UIViewController.defaultProps = {
  size: 'small'
};
UIViewController.displayName = 'UIViewController';
export default Controllable(UIViewController);